import { Link } from 'react-router-dom';

import './link-with-background.css';


export function LinkWithBackground(props){

    const data = props.data;
    const {url, text, background="", color="", fontSize="", margin="", padding=""} = data;

    const linkStyle = {
        "background" : background,
        "color" : color,
        "fontSize" : fontSize,
        "margin" : margin,
        "padding" : padding,
        '&:hover, &:focus, &:active, &:visited': {
            "color" : color
        }
    }

    return(
        <>
            <Link to={url} className='link-with-background' style={linkStyle}>
                {text}
            </Link>
        </>
    );

}